<template>
  <section>

    <div>
    <!-- //TITLE MOBILE -->
    <h1 class="mobile">{{content.objective}}</h1>
    <!-- //TITLE MOBILE -->

    <div class="content__objective">


      <!-- //TITLE DESKTOP -->
      <h1 class="desktop">{{content.objective}}</h1>
      <!-- //TITLE DESKTOP -->
      

      <!-- SLIDER MOBILE -->
      <div class="block__slider cardSimple mobile">
        <VueSlickCarousel v-bind="settings">
          <div  class="wrapper">
            <b-card class="card-simple">

              <div class="header d-flex align-items-center">
                <div class="number">
                  <PuSkeleton :loading="isLoading" :count="1">                    
                    12
                  </PuSkeleton>
                </div>
              <PuSkeleton circle  class="ml-4" :loading="isLoading" :count="1" width="30px" height="30px">
                <div class="target">+1</div>
              </PuSkeleton>
              </div>
              
              <div class="title">
                <PuSkeleton :loading="isLoading" :count="1">                  
                  {{content.objectiveAdvance}}
                </PuSkeleton>
              </div>
              
            </b-card>
          </div>

          <div  class="wrapper">
            <b-card class="card-simple text-yellow">
              <div class="header d-flex align-items-center">
                <div class="number">
                  <PuSkeleton :loading="isLoading" :count="1">                    
                    23
                  </PuSkeleton>                  
                </div>
                <PuSkeleton circle  class="ml-4" :loading="isLoading" :count="1" width="30px" height="30px">
                  <div class="target">+1</div>
                </PuSkeleton>
              </div>           
            <div class="title">
                <PuSkeleton :loading="isLoading" :count="1">                  
                  {{content.objectiveLate}}
                </PuSkeleton>              
            </div>
            </b-card>       
          </div>

          <div  class="wrapper">
            <b-card class="card-simple text-white green">
              <div class="number">
                <PuSkeleton :loading="isLoading" :count="1">                    
                  2
                </PuSkeleton>                
              </div>
              <div class="title">
                <PuSkeleton :loading="isLoading" :count="1">                  
                  {{content.objectiveDone}}
                </PuSkeleton>                
              </div>
            </b-card>
          </div>
        </VueSlickCarousel>
      </div>
      <!-- SLIDER MOBILE -->

      <!-- //CARD SIMPLE DESKTOP -->
      <b-row class="block__cardSimple">
        <b-col cols="4">
          <b-card class="card-simple">
            <div class="header d-flex align-items-center">
              <div class="number">
                <PuSkeleton :loading="isLoading" :count="1" width="60px">                
                  12
                </PuSkeleton>
              </div>
              <PuSkeleton circle class="ml-4" :loading="isLoading" :count="1" width="30px" height="30px">
                <div class="target">+1</div>
              </PuSkeleton>
            </div>
            <div class="title">
              <PuSkeleton :loading="isLoading" :count="1">              
                  {{content.objectiveAdvance}}
              </PuSkeleton>
            </div>
          </b-card>
        </b-col>
        <b-col cols="4">
          <b-card class="card-simple text-yellow">
            <div class="header d-flex align-items-center">
              <div class="number">
                <PuSkeleton :loading="isLoading" :count="1" width="60px">                
                  23
                </PuSkeleton>
              </div>
              <PuSkeleton circle  class="ml-4"  :loading="isLoading" :count="1" width="30px" height="30px">
                <div class="target">+1</div>
              </PuSkeleton>
            </div>           
          <div class="title">
            <PuSkeleton :loading="isLoading" :count="1">            
              {{content.objectiveLate}}
            </PuSkeleton>
          </div>
          </b-card>
        </b-col>
        <b-col cols="4">
          <b-card class="card-simple text-white green">
            <div class="number">
              <PuSkeleton :loading="isLoading" :count="1" width="60px">              
                2
              </PuSkeleton>
            </div>
            <div class="title">
              <PuSkeleton :loading="isLoading" :count="1">              
                {{content.objectiveDone}}
              </PuSkeleton>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <!-- //CARD SIMPLE DESKTOP -->


      <b-row>

      <!-- //SEP -->
      <div class="sep desktop"></div>
      <!-- //SEP -->  


        <b-col>

          <div class="entete">
              <span class="fas fa-chart-bar"></span>
              <p>Production</p>
          </div>

        </b-col>

        <b-col cols="12">

        <!-- TABS -->
        <b-tabs content-class="mt-3">

          <b-tab title="Nombre" active>
            <b-row>
                <b-col sm="12" lg="6" v-for="card in cards" :key="card.id">
                  <cardObjectiveChart 
                  :parent = $route.path
                  :link = card.id
                  :title = card.title
                  :allNumber = card.allNumber
                  :resultOne = card.resultOne
                  :differences = card.difference
                  :date = card.date
                  :chart = card.chart
                  :isNegative = card.isNegative
                  :isDone = card.isDone
                  />
                </b-col>
            </b-row>
          </b-tab>

          <b-tab title="Montant">
            <p>I'm the second tab</p>
          </b-tab>

          <b-tab title="%UC">
            <p>I'm the second tab</p>
          </b-tab>

        </b-tabs>
        <!-- TABS -->

        </b-col>

      </b-row>


      <sidebar class="mobile" />

      </div>
    </div>

    <!-- /////////////// ROUTER VIEW -> FIRST CHILD -->
      <transition name="slide">      
        <keep-alive>
          <router-view class="transition"></router-view>
        </keep-alive>
      </transition> 
    <!-- /////////////// ROUTER VIEW -> FIRST CHILD -->

    <!-- /////////////// ROUTER VIEW -> MODAL = CHILDS -->
    <transition name="modal"> 
      <keep-alive>
        <router-view name="helper" class="myModal"></router-view>
      </keep-alive>
    </transition>    
    <!-- /////////////// ROUTER VIEW -> MODAL = CHILDS -->    

  </section>
</template>


<script>
import { mapGetters } from 'vuex'
import cardObjectiveChart from '../../../module/card/CardObjectiveChart'
import Sidebar from '../../../module/sidebar/Sidebar'
import ParentMixin from '../../ParentMixin'
import CatMixin from '../../category/CatMixin'


export default {
  name:"objectiveHome",
    components:{
      cardObjectiveChart,
      Sidebar,
    }, 
    mixins: [
      ParentMixin,
      CatMixin      
    ],      
    computed: {
      ...mapGetters([
        'getProductionCardObjectiveChart',
        'getGeneral',
        'getPageTransition',
      ])
    },
    data () {
      return {
          cards: [],   
          content: [],   
          isLoading:true,
      }
    },
    created (){
      this.cards = this.getProductionCardObjectiveChart;
      this.content = this.getGeneral;
      setTimeout(() => {
          this.isLoading = false;
          // this.majData();
        },2000)      
    },    
    methods : {},
   watch: {
    getPageTransition() {
      this.transition = this.getPageTransition;
      this.scrollIt = this.getScroll;
      console.log('this.transition == ' + this.transition)
    }, 
   }   
};
</script>
